import { azureFetch } from "./azureFetch";
export const fetchData = async (path, requestBody) => {
    try {
        const response = await azureFetch(path, requestBody);
        return response
    } catch (error) {
        console.error("Error fetching sensor data:", error);
        throw error;
    }
};